import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { push } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const updateLastPathParamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.updateLastPathParam),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { locationState, segment } = payload;

    const location = locationSelector(state);
    const pathname = location.pathname.replace(/\/$/, '');
    const end = pathname.lastIndexOf('/');

    // Encode segment to handle special characters like # in symbol names
    const encodedSegment = encodeURIComponent(segment);

    return [
      push({
        ...location,
        pathname: `${pathname.substring(0, end)}/${encodedSegment}`,
      }, locationState),
    ];
  }),
);
